export enum BundleTypeEnum {
  BUNDLE_TYPE = 'BUNDLE',
  PROGRAM_TYPE = 'PROGRAM',
  SPECIALIZATION_TYPE = 'SPECIALIZATION',
  LEARNING_PATH_TYPE = 'LEARNINGPATH',
}
